const items = {
  "labels.week.0": "Sun",
  "labels.week.1": "Mon",
  "labels.week.2": "Tue",
  "labels.week.3": "Wed",
  "labels.week.4": "Thu",
  "labels.week.5": "Fri",
  "labels.week.6": "Sat",
  "labels.collaborators": "collaborators",
  "labels.collaboration": "collaboration",
  "labels.link": "link",
  "labels.upload": "upload",
  "labels.first-term": "first term",
  "labels.sign-in": "sign in",
  "labels.first-wbw": "first wbw",
  "labels.first-translation": "first translation",
  "labels.first-course": "first course",
  "labels.updated-at": "updated at",
  "labels.created-at": "created at",
  "labels.recent-scan": "recent scan",
  "labels.icp": "ICP:",
  "labels.no.login": "not login",
  "labels.page.number.type.M": "Page Number By My",
  "labels.page.number.type.T": "Page Number By Th",
  "labels.page.number.type.P": "Page Number By PTS",
  "labels.page.number.type.V": "Page Number By VRI",
  "labels.page.number.type.O": "Page Number By Other",
  "labels.page.number.type.para": "Paragraph By CS",
  "labels.curr.paragraph.only": "Current Paragraph",
  "labels.curr.paragraph.open": "Open In Tab",
  "labels.curr.paragraph.copy.tpl": "Copy Sn",
  "labels.curr.paragraph.quote.link.tpl": "引用链接模版",
  "labels.curr.paragraph.copy.quote.link.tpl": "复制引用模版",
  "labels.input": "input",
  "labels.selected": "Selected",
  "labels.page.number.type.c": "Chapter Title",
  "labels.loading": "loading",
  "labels.empty": "empty",
  "labels.curr.paragraph.cart.tpl": "Add to Cart",
  "labels.software.edition.guest": "guest",
  "labels.software.edition.basic": "basic",
  "labels.software.edition.pro": "pro",
  "labels.table-of-content": "table of content",
  "labels.this-studio": "this studio",
  "labels.feedback": "feedback",
  "labels.email.sign-up.subject": "welcome join wikipali",
  "labels.sign-up": "Sign Up",
  "labels.done": "Done",
  "labels.tag.list": "tag list",
  "labels.error.401": "未登录",
  "labels.error.403": "没有权限",
  "labels.error.404": "没有找到指定的资源",
  "labels.error.429": "请求过于频繁",
  "labels.error.500": "服务器内部错误",
  "labels.task": "task",
  "labels.task.hall": "task hall",
  "labels.task.mine": "my task",
  "labels.task.my.project": "my projects",
  "labels.all": "all",
  "labels.mention.me": "mention",
  "labels.task.status.pending": "pending",
  "labels.task.status.published": "published",
  "labels.task.status.running": "running",
  "labels.task.status.done": "done",
  "labels.task.status.restarted": "restarted",
  "labels.task.status.requested_restart": "requested restart",
  "labels.task.status.closed": "closed",
  "labels.task.status.canceled": "canceled",
  "labels.task.status.expired": "expired",
  "labels.task.status.queue": "queue",
  "labels.task.status.stop": "stop",
  "labels.task.status.quit": "quit",
  "labels.task.status.pause": "pause",
  "labels.filter": "filter",
  "labels.participants": "participants",
  "labels.task.category": "task category",
  "labels.task.category.translate": "translate",
  "labels.task.category.vocabulary": "vocabulary",
  "labels.task.category.team": "team",
  "labels.task.category.review": "review",
  "labels.task.category.proofread": "proofread",
  "labels.task.category.suggest": "suggest",
  "labels.ai-assistant": "AI Assistant",
  "labels.filters.includes": "includes",
  "labels.filters.not-includes": "not includes",
  "labels.filters.equal": "equal",
  "labels.filters.not-equal": "not equal",
  "labels.filters.null": "null",
  "labels.filters.not-null": "not null",
  "labels.filters.and": "and",
  "labels.filters.or": "or",
  "labels.task.workflows": "Workflows",
  "labels.milestone": "Milestone",
  "labels.flowchart": "Flowchart",
  "labels.table": "Table",
  "labels.list": "List",
  "labels.shared": "Shared",
  "labels.community": "Community",
  "labels.task.prev.executors": "Prev Executors",
};

export default items;
